import { useParams, useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';

import { useAnalysisData, useMessage } from 'pages/trading/queryHooks';
import { LoadingSpinner } from 'components/LoadingSpinner';
import { PromoStyleDetailPage } from 'pages/trading/price/promotion/PromoStyleDetailPage';
import { PriceStyleDetailPage } from './change/PriceStyleDetailPage';

export function StyleDetailRouter() {
  const { messageId } = useParams<{ messageId: string; styleId: string }>();
  const [searchParams] = useSearchParams();

  const { data: message } = useMessage(messageId);
  const { isPending } = useAnalysisData(message?.analysisDataId);

  const isPromotion = searchParams.get('isPromotion') === 'true';

  if (isPending) {
    return (
      <Box className="flex justify-center py-20">
        <LoadingSpinner />
      </Box>
    );
  }

  if (isPromotion) {
    return <PromoStyleDetailPage />;
  }

  return <PriceStyleDetailPage />;
}
